import type { RouteRecordRaw } from 'vue-router'

export const adminRoutes: RouteRecordRaw[] = [
  {
    path: '/admin/login',
    name: 'admin-login',
    component: () => import('@/pages/admin/AdminLogin.vue'),
    meta: { requiresAuth: false }
  },
  {
    // Public invitee-side activation: reached straight from the email link, the invitee sets a
    // password and accepts before they have any admin session, so this route must not require auth.
    path: '/admin/accept/:token',
    name: 'admin-accept-invitation',
    component: () => import('@/pages/admin/AdminAcceptInvitation.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/admin/mfa-setup',
    name: 'admin-mfa-setup',
    component: () => import('@/pages/admin/AdminMfaSetup.vue'),
    meta: { requiresAuth: true, requiresMfa: false }
  },
  {
    path: '/admin',
    component: () => import('@/layouts/AdminLayout.vue'),
    meta: { requiresAuth: true, requiresMfa: true },
    children: [
      {
        path: '',
        name: 'admin-dashboard',
        component: () => import('@/pages/admin/AdminDashboard.vue')
      },
      {
        path: 'organizations',
        name: 'admin-organizations',
        component: () => import('@/pages/admin/AdminOrganizations.vue')
      },
      {
        path: 'organizations/create',
        name: 'admin-org-create',
        component: () => import('@/pages/admin/AdminOrgCreate.vue')
      },
      {
        path: 'organizations/:id',
        name: 'admin-org-detail',
        component: () => import('@/pages/admin/AdminOrgDetail.vue')
      },
      {
        path: 'users',
        name: 'admin-users',
        component: () => import('@/pages/admin/AdminUsers.vue')
      },
      {
        path: 'users/:id',
        name: 'admin-user-detail',
        component: () => import('@/pages/admin/AdminUserDetail.vue')
      },
      {
        path: 'audit-log',
        name: 'admin-audit-log',
        component: () => import('@/pages/admin/AdminAuditLog.vue')
      },
      {
        path: 'admin-users',
        name: 'admin-admin-users',
        component: () => import('@/pages/admin/AdminAdminUsers.vue')
      },
      {
        path: 'admin-users/:id',
        name: 'admin-admin-user-detail',
        component: () => import('@/pages/admin/AdminAdminUserDetail.vue')
      },
      {
        path: 'support-partners',
        name: 'admin-support-partners',
        component: () => import('@/pages/admin/AdminSupportPartners.vue')
      },
      {
        path: 'support-partners/:id',
        name: 'admin-support-partner-detail',
        component: () => import('@/pages/admin/AdminSupportPartnerDetail.vue')
      },
      {
        path: 'subscriptions',
        name: 'admin-subscriptions',
        component: () => import('@/pages/admin/AdminSubscriptions.vue')
      }
    ]
  },
  {
    path: '/',
    redirect: '/admin'
  }
]
